var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabresultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8231_297275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8532 2.16517L2.76724 5.79775L4.76515 8.595L9.85112 4.96244L7.8532 2.16517ZM7.22015 3.43792L6.71152 3.80117L7.98294 5.58127L8.49153 5.21801L7.22015 3.43792ZM5.94863 4.34611L5.44004 4.70936L6.71146 6.48943L7.22005 6.12618L5.94863 4.34611ZM4.67701 5.25419L4.16842 5.61744L5.43983 7.39751L5.94842 7.03426L4.67701 5.25419Z",
    fill: "#5571C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9314 7.76084L9.00016 4.85479L13.5409 11.2122C14.3433 12.3358 14.0831 13.8972 12.9595 14.6996C11.836 15.5021 10.2746 15.2419 9.47209 14.1183L4.9314 7.76084ZM5.80324 7.90618L9.98071 13.755C10.5826 14.5977 11.7536 14.7929 12.5962 14.1911C13.4389 13.5892 13.6341 12.4182 13.0323 11.5755L8.85481 5.72666L5.80324 7.90618Z",
    fill: "#5571C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29273 8.37804L10.09 6.38015L13.1777 10.7032L10.3804 12.7011L7.29273 8.37804ZM8.16461 8.52338L10.5258 11.8293L12.3058 10.5579L9.94467 7.25199L8.16461 8.52338Z",
    fill: "#5571C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27215 10.6131C9.27208 10.6131 9.27221 10.6131 9.27215 10.6131C8.79988 10.7584 8.16413 11.2125 8.00067 11.5213L9.72613 13.9371C10.4283 14.9202 11.7945 15.148 12.7776 14.4458C13.7607 13.7436 13.9885 12.3774 13.2863 11.3943L12.7415 10.6316L10.453 12.2661L9.27215 10.6131Z",
    fill: "#5571C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38788 11.525L9.98071 13.7547C10.5826 14.5974 11.7536 14.7926 12.5962 14.1907C13.4389 13.5888 13.6341 12.4178 13.0323 11.5752L12.6689 11.0667L10.3804 12.7012L9.15891 10.9912C9.01082 11.0595 8.85066 11.1534 8.70224 11.2594C8.56892 11.3547 8.46265 11.4471 8.38788 11.525ZM8.33899 10.7508C8.59505 10.5679 8.90235 10.3992 9.18026 10.3137L9.2202 10.3014L9.42942 10.2945L10.5258 11.8294L12.8142 10.1949L13.5409 11.2119C14.3433 12.3355 14.0831 13.8968 12.9595 14.6993C11.836 15.5018 10.2746 15.2415 9.47209 14.118L7.65554 11.575L7.71131 11.3991L7.72449 11.3743C7.84171 11.1528 8.09192 10.9273 8.33899 10.7508Z",
    fill: "#5571C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8231_297275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(2.46647) rotate(9.46418)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabresultIcon);
export default __webpack_public_path__ + "static/media/labresult_icon.b13d5a7127d9367480ba40340a77a784.svg";
export { ForwardRef as ReactComponent };